// SPDX-License-Identifier: AGPL-3.0-or-later

import {makeAutoObservable} from 'mobx';

export type ChatDetailsTab = 'todos' | 'files';

class ChatDetailsPanel {
	open = false;
	tab: ChatDetailsTab = 'todos';

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
	}

	toggle(): void {
		this.open = !this.open;
	}

	close(): void {
		this.open = false;
	}

	setTab(tab: ChatDetailsTab): void {
		this.tab = tab;
		this.open = true;
	}
}

export default new ChatDetailsPanel();
